import React, { useCallback, useEffect, useRef, useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import "./OtpEntry.scss";
import otpVerificationImage from "../../../assets/images/otp-verification-lock-4x.png";
import { useNavigate } from "react-router-dom";
import {
  useLazyGenerateOtpQuery,
  useLazyMPinExistQuery,
  useLazyValidateOtpQuery,
} from "../Login_Api";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../redux-store/CustomReduxHooks";
import { setError } from "../../../redux-store/reducers/CsErrorSlice";
import { updateLoginData, updateScreenTag } from "../Login_Slice";
import CsLocalStorageUtils from "../../../utils/CsLocalStorageUtils";
import CustomPopup from "../../../components/CustomPopup/CustomPopup";
import { Colors } from "../../../styles/constant";
import CommonGifAnimation from "../../../components/CustomGifAnimation/CommonGifAnimation";
import {
  E_ChannelOptions,
  LoginScreenValues,
  T_AnimationData,
  T_ApiResponse,
} from "../../../globalTypes/GlobalTypes";
import ExclamationMarkGif from "../../../assets/gif/Exclamation_Mark.json";
import {
  DEVICE_TYPE,
  functionalityCodeForGenerateOtpApi,
  GTAScreenType,
  onUserLoginCleverTapStatic,
  otpScreenErrorMsg,
  SCREEN_TYPE,
} from "../../../utils/constants";
import CsSessionStorageUtils from "../../../utils/CsSessionStorageUtils";
import { T_GenerateOtpPay } from "../Login_Types";
import { CleverTapEventType } from "../../../utils/CleverTapConstant";
import { CT_ScreenEvntDtls } from "../../Feature_CleverTap/ScreenEvents/CleverTapEventDetails";
import cleverTap, { triggerCleverTapEvent } from "../../../utils/CleverTap";
import TriggerGTAEvent from "../../../utils/GTA";
import { MuiOtpInput } from "mui-one-time-password-input";
import { API_STATUS_CODE } from "../../../utils/ApiEndpoints";
import { useReadOTP } from "./ReadOtp";
import AuthBootstrapBridge from "../../../routes/Guards/AuthBootstrapBridge";
import useWindowSize from "../../../hooks/useWindowSize";
import { isEmpty } from "lodash";
import ArrowRightIcon from "../../../assets/icons/red-arrow-right.svg";
import mPINLockImage from "../../../assets/images/mpin-lock-4x.png";
import { R_GeneralElementsRoutes } from "../../../utils/Routes";
import useDeviceDetection from "../../../hooks/useDeviceDetection";

declare const window: any;

type ChildComponentProps = {
  onMaximumAttempt: () => void;
  headerText: string;
};

const OtpEntry: React.FC<ChildComponentProps> = ({
  headerText,
  onMaximumAttempt,
}) => {
  const masterDetails = useAppSelector(
    (state) => state.GeneralAppElementsSlice.masterData?.masterDetail,
  );
  const csAppSlice = useAppSelector((state) => state.CsAppSlice);
  const secondaryChannelSlice = useAppSelector(
    (state) => state.SecondaryChannelSlice,
  );

  const wrongOtpCountAllowed = parseInt(
    masterDetails?.wrong_otp_count_allowed?.find(
      (item) => item.masterKey === "limit",
    )?.masterValue || "3",
  );
  const retryCount = parseInt(
    masterDetails?.retry_count?.find(
      (item) => item.masterKey === "otpBypassValue",
    )?.masterValue || "3",
  );
  const { width } = useWindowSize();
  const [otpVerifyAttemptLeft, setOtpVerifyAttemptLeft] =
    useState<number>(wrongOtpCountAllowed);
  const [reSendOtpAttemptLeft, setReSendOtpAttemptLeft] =
    useState<number>(retryCount);
  const [count, setCount] = useState<number>(60);
  const [validateOtpApi] = useLazyValidateOtpQuery();
  const [generateOtpApi] = useLazyGenerateOtpQuery();
  const isTimerOn = useRef(true);
  const [isMpinExist, setIsMpinExist] = useState(false);
  const [isMpinCheckEnable, setIsMpinCheckEnable] = useState(false);
  const [otp, setOtp] = useState<string>("");
  const [helperTextOtp, setHelperTextOtp] = useState<string>("");
  const appDispatch = useAppDispatch();
  const loginSlice = useAppSelector((state) => state.LoginSlice);
  const mobileNumber = loginSlice.mobilenumber || "";
  const deviceType = useDeviceDetection();

  const emailIdFromConsent = useAppSelector(
    (state) => state.CsAppSlice.emailId,
  );
  const [authGuardEnabled, initAuthGuardChecks] = useState(false);
  const navigate = useNavigate();

  const [mPinCheckApi] = useLazyMPinExistQuery();
  const dispatch = useAppDispatch();
  function getMinutesBetweenDates(startDate: Date, endDate: Date) {
    const diff = endDate.getTime() - startDate.getTime();

    return diff / 60000;
  }
  useReadOTP(setOtp);

  useEffect(() => {
    if (
      (deviceType === DEVICE_TYPE.PWA_MOBILE ||
        deviceType === DEVICE_TYPE.MOBILE) &&
      !isEmpty(csAppSlice?.NativeDeviceInfo?.deviceName) &&
      csAppSlice?.channel === E_ChannelOptions.CSAPP &&
      loginSlice.screenTag === LoginScreenValues.enterOtpScreen
    ) {
      setIsMpinCheckEnable(true);
      checkIfMpinExists();
    }
  }, []);

  useEffect(() => {
    triggerCleverTapEvent(CleverTapEventType.SCREEN_EVENT, {
      ScreenName: CT_ScreenEvntDtls.R_GAE.gaLoginMobNumOtpVer.screenName,
      ScreenType: SCREEN_TYPE.LoginScreenType,
    });

    const messageOtpHandler = (event: CustomEvent) => {
      console.log("OTP Message from React Native Android: ", event.detail);
      setOtp(event.detail);
      // Handle the incoming message
    };
    window.addEventListener("on_receive_otp", messageOtpHandler);
    return () => {
      window.removeEventListener("on_receive_otp", messageOtpHandler);
    };
  }, []);

  useEffect(() => {
    if (otpVerifyAttemptLeft > 0) {
      return;
    }
    if (
      CsLocalStorageUtils.get("OTP_BLOCKED_TIME")?.length > 0 &&
      getMinutesBetweenDates(
        new Date(CsLocalStorageUtils.get("OTP_BLOCKED_TIME")),
        new Date(),
      ) < 30
    ) {
      setReSendOtpAttemptLeft(0);
      setOtpVerifyAttemptLeft(0);
    } else {
      CsLocalStorageUtils.clear("OTP_BLOCKED_TIME");
    }
  }, [otpVerifyAttemptLeft]);

  useEffect(() => {
    startTimer();
  }, []);

  const startTimer = useCallback(() => {
    isTimerOn.current = true;
    const intervalId = setInterval(() => {
      setCount((prevCount) => {
        const newCount = prevCount - 1;
        if (newCount <= 0) {
          clearInterval(intervalId);
          isTimerOn.current = false;
          return 60;
        }
        return newCount;
      });
    }, 1000);
  }, []);

  const handleOtpChange = (value: string) => {
    setOtp(value);
    setHelperTextOtp("");

    // If the OTP length is 6, focus out of the input and focus on the submit button
    if (value.length === 6) {
      // Remove focus from the OTP input box
      const activeElement = document.activeElement;
      if (
        activeElement &&
        (activeElement instanceof HTMLInputElement ||
          activeElement instanceof HTMLTextAreaElement)
      ) {
        activeElement.blur(); // This will remove focus from the current input field
      }
      handleActualOtpSubmit(value);
    }
  };

  const gotoNextStep = (status: boolean) => {
    if (!status) {
      return;
    }
    if (headerText === "OTP Verification") {
      navigate("/set-mpin", { replace: true, state: { type: "forgetMpin" } });
    } else if (csAppSlice.channel === E_ChannelOptions.SECONDARY_CHANNEL) {
      navigate(secondaryChannelSlice.constructedAppUrl, {
        state: secondaryChannelSlice.dynamicState,
        replace: true,
      });
    } else {
      navigate("/", { replace: true });
    }
  };

  const handleGotoAbcdApp = useCallback(() => {
    dispatch(updateScreenTag(LoginScreenValues.enterMobileScreen));
    navigate("/login");
  }, []);

  const checkIfMpinExists = () => {
    mPinCheckApi({
      mobileNo: mobileNumber,
    }).then((res) => {
      if (res.data?.code === API_STATUS_CODE.SUCCESS) {
        setIsMpinExist(res.data.payload?.mpinExist);
      } else {
        appDispatch(
          setError({
            error: new Error("Error"),
            message: "Check Mpin Exist Api Failed",
          }),
        );
      }
    });
  };

  const goToSetMpin = (screenType: string) => {
    CsLocalStorageUtils.set("MPIN_FOR_MOBILE", "");
    navigate(R_GeneralElementsRoutes.setMpin, {
      replace: true,
      state: { type: screenType },
    });
  };

  const onOtpMatched = (res: any) => {
    appDispatch(
      updateLoginData({
        key: "isOtpVerificationDone",
        value: true,
      }),
    );
    let onUserLoginCleverTapData = { ...onUserLoginCleverTapStatic };
    onUserLoginCleverTapData["Identity"] = "+91" + mobileNumber;
    onUserLoginCleverTapData["Phone"] = "+91" + mobileNumber;
    onUserLoginCleverTapData["MSG-sms"] = true;
    onUserLoginCleverTapData["MSG-whatsapp"] = true;
    onUserLoginCleverTapData["MSG-push"] = !isEmpty(
      csAppSlice.NativeDeviceInfo?.deviceName,
    );

    if (!onUserLoginCleverTapData.DOB) {
      delete onUserLoginCleverTapData.DOB;
    }

    if (isEmpty(csAppSlice.NativeDeviceInfo?.deviceName)) {
      cleverTap.onUserLogin.push({ Site: onUserLoginCleverTapData });
    }
    triggerCleverTapEvent("onUserLogin", {
      ScreenType: SCREEN_TYPE.generalAppType,
      ScreenName: "Servicing Login Mobile Number OTP Verification Screen",
      isPrevPageNameRequired: true,
      ...onUserLoginCleverTapData,
      MSG_email: onUserLoginCleverTapData["MSG-email"],
      MSG_push: onUserLoginCleverTapData["MSG-push"],
      MSG_sms: onUserLoginCleverTapData["MSG-sms"],
      MSG_whatsapp: onUserLoginCleverTapData["MSG-whatsapp"],
    });

    if (headerText === "" && isMpinCheckEnable) {
      if (isMpinExist) {
        CsLocalStorageUtils.set("MPIN_FOR_MOBILE", mobileNumber);
        appDispatch(updateScreenTag(LoginScreenValues.LoginWithMPIN));
        navigate("/login", { replace: true });
      } else {
        goToSetMpin("createMpin");
      }
      return;
    } else if (
      headerText === "OTP Verification" &&
      LoginScreenValues.enterOtpScreenForgotmPIN === loginSlice.screenTag
    ) {
      goToSetMpin("forgetMpin");
      return;
    } else {
      CsSessionStorageUtils.set("LOGGED_IN_TIME", new Date().toISOString());
      appDispatch(updateLoginData({ key: "isUserLoggedIn", value: true }));
      if (res) {
        appDispatch(
          updateLoginData({ key: "displayRateUs", value: res.displayRateUs }),
        );
      }
      initAuthGuardChecks(true);
    }
  };

  const onOtpMatchFailed = () => {
    appDispatch(
      updateLoginData({
        key: "isOtpVerificationDone",
        value: false,
      }),
    );
    if (otpVerifyAttemptLeft > 0) {
      setHelperTextOtp(
        `OTP incorrect, ${otpVerifyAttemptLeft - 1} attempts left`,
      );
      setOtp("");
      setOtpVerifyAttemptLeft((prevCount) => prevCount - 1);
    } else {
      onMaximumAttempt();
    }
  };

  const handleActualOtpSubmit = (otpValue: string = "") => {
    triggerCleverTapEvent("serv_login_mob_no_otp_verify_click", {
      ScreenType: SCREEN_TYPE.generalAppType,
      ScreenName: "Servicing Login Mobile Number OTP Verification Screen",
      isPrevPageNameRequired: true,
      ctaText: "continue",
    });
    TriggerGTAEvent("serv_login_mob_no_otp_verify_click", {
      screen_type: GTAScreenType.LoginScreenType,
      screen_name: "servicing_login_mobile_number_otp_verification_screen",
      CTA_text: "continue",
    });
    validateOtpApi({
      mobileNo: mobileNumber,
      otp: otpValue || otp,
    })
      .then((res) => {
        const mobileNoFromRes = res?.data?.payload?.mobileNo;
        if (res.data?.code === 1 && mobileNoFromRes === mobileNumber) {
          onOtpMatched(res.data?.payload);
        } else {
          onOtpMatchFailed();
        }
      })
      .catch((err: Error) => {
        appDispatch(
          setError({
            error: err,
            message: err.message,
          }),
        );
      });
  };

  const sendOtp = () => {
    TriggerGTAEvent("serv_login_mob_no_resend_otp_click", {
      screen_type: GTAScreenType.LoginScreenType,
      screen_name: "serv_login_setup_mpin_details_enter_screen",
      CTA_text: "resend_otp",
      isPrevPageNameRequired: true,
    });
    setOtp("");
    const requestParams: T_GenerateOtpPay = {
      mobileNo: mobileNumber,
      otp: "",
      functionality: functionalityCodeForGenerateOtpApi,
      emailRequired: true,
    };

    if (emailIdFromConsent && emailIdFromConsent.trim() !== "") {
      requestParams.emailId = emailIdFromConsent;
    }

    generateOtpApi(requestParams)
      .then((r) => {
        if (r.isError && r.error) {
          const e =
            (r.error as T_ApiResponse<any>) || Error("Something went wrong");
          if (e?.code === API_STATUS_CODE.BUSINESS_ERROR) {
            setReSendOtpAttemptLeft(0);
            setOtpVerifyAttemptLeft(0);
          }
        } else if (!r.error && r.data?.code === API_STATUS_CODE.SUCCESS) {
          setReSendOtpAttemptLeft((prev) => prev - 1);
          startTimer();
        } else {
          appDispatch(
            setError({
              error: r.data,
              message: r.data?.message,
            }),
          );
        }
      })
      .catch((err: Error) => {
        appDispatch(setError({ error: err, message: err.message }));
      });
  };

  let finalVerifyAttemptMessage: string = "";
  if (otpVerifyAttemptLeft <= 0 || reSendOtpAttemptLeft <= 0) {
    finalVerifyAttemptMessage = otpScreenErrorMsg;
    // CsLocalStorageUtils.set("OTP_BLOCKED_TIME",dayjs().toString());
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default behavior
      handleActualOtpSubmit(); // Call your confirm function
    }
    if (e.key === "Delete") {
      if (otp.length > 0) {
        // Handle deletion: you can remove the last character or handle it as needed
        setOtp((prevOtp) => prevOtp.slice(0, -1));
        // Focus management after deleting: focus on the previous field when deleting
        const focusedIndex = otp.length - 1;
        if (focusedIndex > 0) {
          // Focus on the previous input (if exists)
          const inputs = document.querySelectorAll("input.otp-input");
          if (inputs[focusedIndex - 1]) {
            (inputs[focusedIndex - 1] as HTMLInputElement).focus();
          }
        }
      }
    }
  };

  return (
    <Box
      className="enter-otp-wrapper"
      minWidth={"12.5rem"}
      width={"100%"}
      maxWidth={"23.9375rem"}
    >
      <CustomPopup
        open={otpVerifyAttemptLeft <= 0 || reSendOtpAttemptLeft <= 0}
        handleOpen={() => {}}
      >
        <Box padding="1.5rem 1rem">
          <Box
            display="flex"
            justifyContent="center"
            flexDirection={"column"}
            textAlign={"center"}
            alignItems={"center"}
          >
            <CommonGifAnimation
              animationData={ExclamationMarkGif as T_AnimationData}
            />
            <Typography
              marginTop={"2rem"}
              variant="h3"
              color={Colors.textblack}
            >
              {finalVerifyAttemptMessage}
            </Typography>
            <Button
              sx={{ width: "100%", marginTop: "2rem" }}
              type="button"
              variant="contained"
              onClick={handleGotoAbcdApp}
            >
              Go to ABC Login Page
            </Button>
          </Box>
        </Box>
      </CustomPopup>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <img
          src={
            headerText === "mPIN otp verification"
              ? mPINLockImage
              : otpVerificationImage
          }
          alt="otp"
          style={{ width: "4.8125rem", height: "4.8125rem" }}
        />
        <Typography
          textAlign="center"
          marginTop={headerText === "mPIN otp verification" ? "1rem" : "1.5rem"}
          variant={"h2"}
          fontSize={
            headerText === "mPIN otp verification" ? "1.5rem" : "1.25rem"
          }
        >
          {headerText === "mPIN otp verification"
            ? "Welcome to ABC"
            : "OTP Verification"}
        </Typography>
        <Typography
          textAlign="center"
          marginTop=".25rem"
          variant="subtitle2"
          color={Colors.textGray}
          width="75%"
        >
          Enter the 6 digit code sent to{" "}
          <span style={{ color: Colors.red, fontWeight: 500 }}>
            {mobileNumber}
          </span>
          {!isEmpty(emailIdFromConsent) && " and your registered email Id"}
        </Typography>
      </Box>

      <Box width={"90%"} marginX={"auto"}>
        <input
          type="text"
          inputMode="numeric"
          autoComplete="one-time-code"
          style={{ display: "none" }}
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
          autoFocus
        />

        <MuiOtpInput
          className={`otp-input ${helperTextOtp.length > 0 ? "error" : ""}`}
          length={6}
          value={otp}
          onChange={handleOtpChange}
          onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) =>
            handleKeyDown(e)
          }
          validateChar={(char) => /^[0-9]$/.test(char)}
          TextFieldsProps={(index) => {
            return {
              inputProps: {
                inputMode: "numeric",
                autoComplete: "one-time-code",
                pattern: "[0-9]*",
              },
            };
          }}
        />
        <Box marginLeft={width < 420 ? "0rem" : "1.4rem"}>
          {helperTextOtp && (
            <Box
              display="flex"
              gap={".25rem"}
              alignItems="center"
              marginBottom=".25rem"
            >
              <Typography color="#D34528" fontSize={14} fontWeight={400}>
                {helperTextOtp}
              </Typography>
            </Box>
          )}
          {isTimerOn.current ? (
            <Typography
              sx={{
                fontWeight: "500",
                fontSize: ".875rem",
                lineHeight: "1.05rem",
                color: "#9C9C9C",
                height: ".875rem",
              }}
            >
              {`Resend OTP in 00:${count.toString().padStart(2, "0")}s`}
            </Typography>
          ) : !isTimerOn.current && reSendOtpAttemptLeft > 0 ? (
            <Button
              id="resendOtp"
              variant="text"
              color="primary"
              sx={{ fontWeight: 500 }}
              onClick={() => {
                if (otpVerifyAttemptLeft > 0) {
                  sendOtp();
                }
              }}
              endIcon={
                <img
                  src={ArrowRightIcon}
                  alt="right-arrow"
                  style={{ color: Colors.red, width: ".75rem" }}
                />
              }
            >
              {"Resend OTP"}
            </Button>
          ) : null}
        </Box>
        {authGuardEnabled && <AuthBootstrapBridge onResult={gotoNextStep} />}
      </Box>
    </Box>
  );
};

export default OtpEntry;
